type PathLocation = {
  pathname: string;
  search?: string;
  hash?: string;
};

/** Accept only same-origin path-style URLs (no open redirects). */
export function parseReturnToPath(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const t = value.trim();
  if (!t.startsWith('/') || t.startsWith('//')) return undefined;
  if (t.includes('://') || /[\r\n]/.test(t)) return undefined;
  return t;
}

export function buildReturnToPath(location: PathLocation): string {
  return `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`;
}
